import { z } from "zod";

import { ALL_CALCULATIONS } from "~/tools/calculate-value-from-points";
import { filter } from "~/tools/filter";
import { identity } from "~/tools/identity";
import { ImmutableSet } from "~/tools/immutable-set";
import { isPresent } from "~/tools/is-present";
import { sortBy } from "~/tools/sort-by";

import type { Settings } from "../../../components/widget-form/legend/settings";
import { ALL_MODES, ALL_POSITIONS, DEFAULT } from "../../../components/widget-form/legend/settings";
import { partial, tuple } from "../../_decoders";
import { Encoder } from "../../_encoder";

const decoder = tuple([
	z.boolean().optional().catch(undefined),

	z.enum(ALL_POSITIONS).optional().catch(undefined),

	z.enum(ALL_MODES).optional().catch(undefined),

	z
		.array(z.enum(ALL_CALCULATIONS).optional().catch(undefined))
		.transform(filter(isPresent))
		.transform(ImmutableSet.fromArray)
		.optional()
		.catch(undefined),
])
	.transform(([show, position, mode, columns]) => partial<Settings>({ show, position, mode, columns }))
	.catch(undefined);

function encoder(settings: undefined | Settings): Encoder {
	return Encoder.tuple(
		Encoder.primitive(settings?.show, DEFAULT.show),
		Encoder.primitive(settings?.position, DEFAULT.position),
		Encoder.primitive(settings?.mode, DEFAULT.mode),

		Encoder.list(
			// the legend table columns definition is order agnostic
			sortBy(settings?.columns?.toArray() ?? DEFAULT.columns.toArray(), identity),
			sortBy(DEFAULT.columns.toArray(), identity),
			(calculation) => Encoder.primitive(calculation),
		),
	);
}

export { decoder, encoder };
